export default {
  height: 'auto',
  calcHeight: 350,
  tip: true,
  border: true,
  index: false,
  selection: true,
  viewBtn: true,
  addBtn: false,
  editBtn: false,
  menuType: 'text',
  refreshBtn:true,
  stripe:true,
  selectClearBtn:true,
  column: [
    {
      label: '所属车场/车库',
      prop: 'parentName',
      hide: false,
      addDisplay: true,
      editDisplay: true,
      readonly: true,
      span: 8,
    },
    {
      label: '车位编号',
      prop: 'parkSpaceNo',
      hide: false,
      addDisplay: true,
      editDisplay: true,
      readonly: true,
      span: 8,
    },
    {
      label: '车位状态',
      prop: 'carParkStatus',
      hide: false,
      addDisplay: true,
      editDisplay: true,
      readonly: true,
      dicUrl: 'api/blade-system/dict/dictionaryWithIntKey?code=car_park_status',
      props: { label: 'dictValue', value: 'dictKey' },
      span: 8,
    },
    /*{
      label: '本级属性',
      prop: 'objectType',
      hide: true,
      addDisplay: true,
      editDisplay: true,
      viewDisplay: true,
      type: 'select',
      dicUrl: 'api/blade-system/dict/dictionary?code=object_type',
      props: { label: 'dictValue', value: 'dictKey' },
      span: 8,
    },*/
  ],
};
